import React, { useState, useEffect, useRef } from "react";
import { AutocompleteField, Box, Chip, Typography } from '@curves/ui-base';

import useClubApi from "@Apis/useClubApi";
const ClubSelector = ({ selectedClubs = [], onClubChange }) => {
	const [clubOptions, setClubOptions] = useState([]);
	const [defaultClubSelectValue, setDefaultClubSelectValue] = useState(null);
	const clubSelectorRef = useRef(null);
	const { getClubsOptionsApi } = useClubApi();
	const hasInit = useRef(false); 
	useEffect(() => {
		if (hasInit.current) return;
		(async () => {
			// options API 回傳 { clubOptions, clubStatusOptions }，本頁只用店舖清單
			const resp = await getClubsOptionsApi();
			const options = resp?.clubOptions ?? [];
			setClubOptions(options);
			if (options.length && selectedClubs.length === 0) {
				onClubChange(options.map(o => o.value)); // 預設全選
			}
			hasInit.current = true;
		})();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	const handleClubChange = newValue => {
		if (Array.isArray(newValue)) {
			onClubChange(newValue.map(item => item.value));
		} else {
			onClubChange([]);
		}
	};
	const handleClubRemove = clubId => {
		onClubChange(selectedClubs.filter(id => id !== clubId));
	};
	// 設定預設值
	useEffect(() => {
		if (selectedClubs.length > 0) {
			setDefaultClubSelectValue(clubOptions.filter(option => selectedClubs.includes(option.value)));
		} else {
			setDefaultClubSelectValue(clubOptions);
		}
	}, [selectedClubs, clubOptions]);
	return (
		<Box>
			<Typography variant="h6" style={{ marginBottom: 12 }}>
				店舖篩選
			</Typography>
			<AutocompleteField
				inputProps={{ placeholder: "請輸入店名/店碼" }}
				options={clubOptions}
				optionKeys={["text"]}
				direction="row"
				primaryKey={"value"}
				defaultValue={defaultClubSelectValue}
				onChange={handleClubChange}
				fullWidth
				ref={clubSelectorRef}
				multiple
			/>
			{selectedClubs.length > 0 && (
				<Box>
					{selectedClubs.slice(0, 3).map(clubId => {
						const club = clubOptions.find(c => c.value === clubId);
						return <Chip key={clubId} label={club ? club.text : `店鋪${clubId}`} size="small" onDelete={() => handleClubRemove(clubId)} />;
					})}
					{selectedClubs.length > 3 && <Chip label={`+${selectedClubs.length - 3} 間`} size="small" variant="outlined" />}
				</Box>
			)}
		</Box>
	);
};
export default ClubSelector;
